export class UserRoleConstants {
  static User: string = 'User';
  static Finance: string = 'Finance';
  static Manager: string = 'Manager';
  static Director: string = 'Director';
  static Admin: string = 'Admin';
}
